import styled from 'styled-components'
import { white, grayLighter } from '@bufferapp/ui/style/colors'

/**
 *
 */

export const Wrapper = styled.div`
  width: 100%;
  padding: 16px;
  background: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'withBg' does not exist on type 'ThemedSt... Remove this comment to see the full error message
    props.withBg ? grayLighter : white};

  & > :not(:last-child) {
    margin-bottom: 8px;
  }
`
